export default __webpack_public_path__ + "static/media/second.019c6d56.jpeg";